import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import PeriodicWorkflowDetail from '@/features/Workflow/WorkflowDetail/periodic/PeriodicWorkflowDetail';
import RealtimeWorkflowDetail from '@/features/Workflow/WorkflowDetail/realtime/RealtimeWorkflowDetail';
import SignalAlertWorkflowDetail from '@/features/Workflow/WorkflowDetail/signal-alert/SignalAlertWorkflowDetail';
import Subscription2WorkflowDetail from '@/features/Workflow/WorkflowDetail/subscription2/SubscriptionWorkflowDetail';
import useAppInit from '@/hooks/domain/App/useAppInit';
import service from '@/services/index';
import {
  WORKFLOW_SUBSCRIPTION_BASIS,
  WORKFLOW_TYPE,
} from '@/types/workflowConst';

const WorkflowDetailPage = () => {
  const appInit = useAppInit();
  const workflow_alias = useParams().workflow_alias as string;

  const { data } = useQuery({
    queryKey: ['workflow-detail', workflow_alias],
    queryFn: () => service.workflow.fetchWorkflow(workflow_alias),
    enabled: appInit,
  });

  return (
    <>
      {data?.type === WORKFLOW_TYPE.PERIODIC && (
        <PeriodicWorkflowDetail mode="EDIT" initialState={data} />
      )}
      {data?.type === WORKFLOW_TYPE.REALTIME && (
        <RealtimeWorkflowDetail mode="EDIT" initialState={data} />
      )}
      {data?.type === WORKFLOW_TYPE.SUBSCRIPTION && (
        <>
          {data.subscription.basis ===
            WORKFLOW_SUBSCRIPTION_BASIS.DASHBOARD2 && (
            <Subscription2WorkflowDetail mode="EDIT" initialState={data} />
          )}
        </>
      )}
      {data?.type === WORKFLOW_TYPE.SIGNAL_ALERT && (
        <SignalAlertWorkflowDetail mode="EDIT" initialState={data} />
      )}
    </>
  );
};

export default WorkflowDetailPage;
